<template>
  <div class="footer">
    <div class="title">
      立即接入KBmob，开启高价值变现之旅
    </div>
    <div class="btn-box">
      <div class="btn" @click="goToAdmin">立即注册</div>
    </div>
<!--    <div class="footer-copyright-box">-->
<!--      © 2024 KBmob. All rights reserved.-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    goUrl(url){
      window.open(url);
    },
    goToAdmin(){
      this.goUrl('https://admin.kuaibian.top/register');
    }
  }
}
</script>

<style lang="less">
.footer{
  width: 100%;
  height: 398px;
  background: #FFFFFF;
  background-size: 100% 398px;
  position: relative;
  text-align: center;
  .title {
    padding-top: 80px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 34px;
    color: #333333;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }
  .btn-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    .btn {
      margin-top: 80px;
      width: 164px;
      height: 60px;
      background: #10D294;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 60px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
      border-radius: 5px;
    }
  }
  .footer-copyright-box {
    width: 100%;
    height: 94px;
    position: absolute;
    bottom: 0;
    left: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #666666;
    line-height: 94px;
    text-align: center;
    font-style: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer-menu.vue